import { createApp } from 'vue'
import { createPinia } from 'pinia'
//import { useClimaticStore } from '@/stores'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')

//const climaticStore = useClimaticStore()
//climaticStore.fetchAllSites()
//climaticStore.init();
